import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router";
import { Menu, Tag, Tooltip, Button } from "antd";
import { HomeOutlined, SwitcherOutlined, AppstoreOutlined, CustomerServiceOutlined, LinkOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
const { Item: MenuItem, ItemGroup: MenuItemGroup, SubMenu } = Menu;
import Logo from "../common/logo";
import { withUser } from "@unifiedpatents/sso";

const styles = {
  logoContainer: {
    width: "100%",
    height: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 16,
    paddingBottom: 8,
    background: "#000c17" // match dark menu
  },
  logoText: {
    fontSize: "20px",
    color: "#fff",
    marginLeft: 4
  },
  quickButtonsContainer: {
    textAlign: "center",
    background: "#000c17" // match dark menu
  }
};

class Nav extends Component {
  static propTypes = {
    onMenuItemClick: PropTypes.func
  };

  static defaultProps = {
    onMenuItemClick: () => { }
  };

  render() {
    const { user } = this.props;
    const { status, action } = user;
    const currentPathname = this.props.location.pathname || "/";
    const adminLinksMenuItems = [
      {
        subheader: "Admin Links",
        items: [
          {
            link: "https://manage.auth0.com/",
            text: "Users"
          },
          {
            link: "https://portal.unifiedpatents.com/",
            text: "Portal"
          },
          {
            link: "http://portal-staging.unifiedpatents.com/",
            text: "Portal (Staging)"
          },
          {
            link: "https://annie.unifiedpatents.com/",
            text: "Annotation"
          },
          {
            link: "https://annie-staging.unifiedpatents.com/",
            text: "Annotation (Staging)"
          },
          {
            link: "https://patroll.unifiedpatents.com/",
            text: "Patroll"
          },
          {
            link: "https://patroll-staging.unifiedpatents.com/",
            text: "Patroll (Staging)"
          }
        ]
      }
    ];
    const unifiedLinksMenuItems = [
      {
        subheader: "Unified Network",
        items: [
          {
            link: "https://www.unifiedpatents.com/",
            text: "Patents"
          },
          {
            link: "https://www.unifiedbrands.us/",
            text: "Brands"
          },
          {
            link: "http://www.unified-consulting.com/",
            text: "Consulting"
          },
          {
            link: "https://patroll.unifiedpatents.com/",
            text: "Patroll"
          }
        ]
      }
    ];
    const selectedMenuKeys = [
      currentPathname.indexOf("/standards/opal/") >= 0
        ? currentPathname.match(/\/standards\/opal\/\w+/)[0]
        : currentPathname.indexOf("/patents/portfolio") >= 0
          ? "/patents/portfolio"
          : currentPathname
    ];
    return (
      <Fragment>
        <Link to="/">
          <div style={styles.logoContainer}>
            <Logo size="28px" />
            <span style={styles.logoText}>{"PORTAL"}</span>
          </div>
        </Link>
        <div style={styles.quickButtonsContainer}>
          <Tooltip title="Home" placement="bottom">
            <Button type="link" icon={<HomeOutlined />} aria-label="Home" href="/" />
          </Tooltip>
          <Tooltip title="Support" placement="bottom">
            <Button type="link" icon={<CustomerServiceOutlined />} aria-label="Support" href="//support.unifiedpatents.com/hc/en-us" target="_blank" rel="noopener noreferrer" />
          </Tooltip>
          <Tooltip title={status.isLoggedIn ? "Logout" : "Login / Sign Up"} placement="bottom">
            <Button
              type="link"
              icon={status.isLoggedIn ? <LogoutOutlined /> : <UserOutlined />}
              aria-label={status.isLoggedIn ? "Log Out" : "Log In / Sign Up"}
              onClick={status.isLoggedIn ? action.logout : action.showLoginPopup}
            />
          </Tooltip>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          onClick={this._handleMenuItemClick}
          defaultOpenKeys={["/" + currentPathname.split("/")[1]]}
          selectedKeys={selectedMenuKeys}
          inlineIndent={16}
          forceSubMenuRender={true}
        >
          <SubMenu
            title={
              <span>
                <SwitcherOutlined />
                <span>US Challenges</span>
              </span>
            }
            key={"/us-challenges"}
          >
            <SubMenu
              title={
                <span>
                  <SwitcherOutlined />
                  <span>PTAB</span>
                </span>
              }
              key={"/ptab"}
            >
              <MenuItem key="/ptab/caselist">{"Cases"}</MenuItem>
              <SubMenu title="Analytics" key="/ptab/analytics">
                <MenuItemGroup title="Case Level">
                  <MenuItem key="/ptab/analytics/case-level/by-status-and-phase">{"Status & Phase"}</MenuItem>
                  <MenuItem key="/ptab/analytics/case-level/by-sector-and-entity-type">{"Sector & Entity Type"}</MenuItem>
                  <MenuItem key="/ptab/analytics/case-level/by-date">{"Activity"}</MenuItem>
                  <MenuItem key="/ptab/analytics/case-level/top-parties">{"Top Parties"}</MenuItem>
                  <MenuItem key="/ptab/analytics/case-level/isix">{"ISIX"}</MenuItem>
                  <MenuItem key="/ptab/analytics/case-level/by-counsel">{"Counsel"}</MenuItem>
                  <MenuItem key="/ptab/analytics/case-level/by-judge">{"Judges"}</MenuItem>
                </MenuItemGroup>
                <MenuItemGroup title="Claim Level">
                  <MenuItem key="/ptab/analytics/claim-level/by-outcome">{"Outcomes"}</MenuItem>
                  <MenuItem key="/ptab/analytics/claim-level/by-counsel">{"Counsel"}</MenuItem>
                  <MenuItem key="/ptab/analytics/claim-level/by-judge">{"Judges"}</MenuItem>
                </MenuItemGroup>
              </SubMenu>
              <MenuItem key="/ptab/annual-report">{"Annual Report"}</MenuItem>
            </SubMenu>
            <SubMenu
              title={
                <span>
                  <SwitcherOutlined />
                  <span>{"Ex-Parte"}</span>
                </span>
              }
              key={"/exparte"}
            >
              <MenuItem key="/exparte/search" itemIcon={<Tag color="#2db7f5">{"Beta"}</Tag>}>{"Cases"}</MenuItem>
              <MenuItem key="/exparte/analytics">{"Analytics"}</MenuItem>
            </SubMenu>
          </SubMenu>
          <SubMenu
            title={
              <span>
                <AppstoreOutlined />
                <span>Intl. Challenges</span>
              </span>
            }
            key={"/intl-challenges"}
          >
            <MenuItem key="/international-challenges/search" itemIcon={<Tag color="#2db7f5">{"Beta"}</Tag>}>{"Challenges"}</MenuItem>
            <MenuItem key="/international-challenges/analytics">{"Analytics"}</MenuItem>
          </SubMenu>
          <SubMenu
            title={
              <span>
                <SwitcherOutlined />
                <span>US Litigation</span>
              </span>
            }
            key={"/litigation"}
          >
            <MenuItem key="/litigation/caselist">{"Cases"}</MenuItem>
            <MenuItem key="/litigation/analytics">{"Analytics"}</MenuItem>
            <MenuItem key="/litigation/annual-report">{"Annual Report"}</MenuItem>
          </SubMenu>
          <SubMenu
            title={
              <span>
                <AppstoreOutlined />
                <span>UPC</span>
              </span>
            }
            key={"/upc"}
          >
            <MenuItem key="/upc/search">{"Cases"}</MenuItem>
            <MenuItem key="/upc/analytics">{"Analytics"}</MenuItem>
          </SubMenu>
          <SubMenu
            title={
              <span>
                <SwitcherOutlined />
                <span>Patent</span>
              </span>
            }
            key={"/patents"}
          >
            <MenuItem key="/patents/search">{"Search "}</MenuItem>
            <SubMenu title="Analytics" key="/patents/analytics">
              <Menu.Item key="/patents/analytics/top-assignees">{"Top Assignees"}</Menu.Item>
              <Menu.Item key="/patents/analytics/top-law-firms">{"Top Law Firms"}</Menu.Item>
              <Menu.Item key="/patents/analytics/ptab-and-litigation">{"PTAB and Litigation"}</Menu.Item>
              <Menu.Item key="/patents/analytics/by-date">{"By Date"}</Menu.Item>
            </SubMenu>
            <MenuItem key="/prosecution">{"Prosecution"}</MenuItem>
            <MenuItem key="/patents/invalidity" itemIcon={<Tag color="#2db7f5">{"Beta"}</Tag>}>{"Pearl"}</MenuItem>
            <MenuItem key="/patents/portfolio">{"Portfolio"}</MenuItem>
            <MenuItem key="/patents/prior-art">{"Prior Art"}</MenuItem>
          </SubMenu>
          <SubMenu
            title={
              <span>
                <AppstoreOutlined />
                <span>OPAL</span>
              </span>
            }
            key="/standards/opal"
          >
            <MenuItem key="/standards/opal/hevc">{"MPEG"}</MenuItem>
            <MenuItem key="/standards/opal/5g">{"3GPP"}</MenuItem>
            <MenuItem key="/standards/opal/wifi6">{"IEEE"}</MenuItem>
            <MenuItem key="/standards/opal/genai">{"GenAI"}</MenuItem>
          </SubMenu>
          <SubMenu
            title={
              <span>
                <AppstoreOutlined />
                <span>OPEN</span>
              </span>
            }
            key="/standards/open"
          >
            <MenuItem key="/standards/open/mpeg">{"MPEG"}</MenuItem>
            <MenuItem key="/standards/open/3gpp">{"3GPP"}</MenuItem>
            <MenuItem key="/standards/open/ieee">{"IEEE"}</MenuItem>
            <MenuItem key="/standards/open/ietf">{"IETF"}</MenuItem>
          </SubMenu>
        </Menu>
        <hr style={{ borderColor: "#000c17" }} />
        {this.renderExternalLinks(unifiedLinksMenuItems, ["Unified Network"])}
        {status.isAdmin && this.renderExternalLinks(adminLinksMenuItems)}
      </Fragment>
    );
  }

  renderExternalLinks = (linksMenuItems, defaultOpenKeys = []) => {
    return (
      <Menu theme="dark" mode="inline" defaultOpenKeys={defaultOpenKeys} selectedKeys={[]} inlineIndent={16}>
        {linksMenuItems.map(section => (
          <SubMenu
            title={
              <span>
                <LinkOutlined />
                <span>{section.subheader}</span>
              </span>
            }
            key={section.subheader}
          >
            {section.items.map(mi => (
              <MenuItem key={mi.text}>
                <a href={mi.link} target="_blank" rel="noopener noreferrer">
                  {mi.text}
                </a>
              </MenuItem>
            ))}
          </SubMenu>
        ))}
      </Menu>
    );
  };

  _handleMenuItemClick = item => {
    let route = {
      pathname: item.key
    };
    if (item.key === "/ptab/caselist") {
      route.query = {
        sort: "-filing_date"
      };
    }
    if (item.key === "/litigation/caselist") {
      route.query = {
        sort: "-filed_date"
      };
    }
    if (item.key.startsWith("/patents/challenges/")) {
      route.pathname = "/patents/analytics/opposition";
      route.query = {
        opposition_country: item.key.replace("/patents/challenges/", "")
      };
    }
    if (item.key.startsWith("/international-challenges")) {
      // Provides default parameters to this route.
      route.query = {
        sort: "-filing_date",
        jurisdiction: ["DE", "GB", "JP", "EP"]
      };
    }
    if (item.key.startsWith("/upc")) {
      route.query = {
        sort: "-filing_date",
        action_application_type: [
          'Application for an Order for inspection pursuant to RoP199',
          'Application for preserving evidence pursuant to RoP192',
          'Application for provisional measures',
          'Application for provisional measures (RoP206)',
          'Counterclaim for revocation',
          'Infringement Action',
          'Revocation Action',
          'Application for legal aid',
          'Action against the decision of the EPO (RoP97)',
          'Declaration of Non-Infringement',
          'Counterclaim for infringement',
          'Application to bar an action proceeding (RoP362)',
          'Application to intervene (RoP313)',
          'APPLICATION_ROP_365',
          'Application to dispose of the action (RoP360)',
          'Request to revoke an Order for preliminary measures (RoP198 and RoP213)',
          'Procedure to substitute a party',
          'Appeal RoP220.1',
          'Appeal RoP220.2',
          'Cross-appeal (RoP237)',
          'Request for a discretionary review (RoP 220.3)',
          'Request for a discretionary review (RoP220.3)',
          'Application for leave to appeal a cost decision (RoP221)',
          'Application to leave to appeal a cost decision (RoP221)',
          'Application to amend a patent'
        ]
      };
    }
    this.props.router.push(route);
    this.props.onMenuItemClick();
  };
}

export default withUser(withRouter(Nav));
